import axios from 'axios';
import { useState } from 'react';
import { HiEyeOff, HiEye } from 'react-icons/hi';
import { ValidationIndividual } from './Validation';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { sortArray } from '../utils';
import { useGetSettings } from '../Hooks/useSettings';

const InitialzedinputError = {};
function Individual() {
  const { countries, getCountryId, getUserTypeId } = useGetSettings();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [instruction, setInstruction] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
  const [inputError, setInputError] = useState(InitialzedinputError);
  const [inputs, setInputs] = useState({
    firstName: '',
    lastName: '',
    personalEmail: '',
    countryCode: '',
    country: '',
    phoneNumber: '',
    userName: '',
    password: '',
    confirmPassword: '',
    refferrerCode: '',
    agree: false,
  });

  const formData = {
    first_name: inputs.firstName,
    last_name: inputs.lastName,
    other_name: inputs.lastName,
    user_type_id: getUserTypeId('Individual user'),
    email: inputs.personalEmail,
    phone: inputs.countryCode + inputs.phoneNumber,
    username: inputs.userName,
    password: inputs.password,
    ref_code: inputs.refferrerCode,
    country: inputs.country,
    country_id: getCountryId(inputs.country),
    agree: inputs.agree,
  };

  const handleChange = (e) => {
    const target = e.target;
    const { value, name, type, checked } = target;
    setInputs((input) => ({
      ...input,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setInputError(ValidationIndividual(inputs));

    if (Object.keys(inputError).length) return;

    try {
      setIsLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/register`,
        formData
      );

      sessionStorage.setItem('user', JSON.stringify(response.data));
      navigate('/otppage', {
        replace: true,
        state: { otpType: 'Register' },
      });
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
    setConfirmPasswordShown(!passwordShown);
  };
  return (
    <div className=' w-full'>
      {/* <div className="min-w-mwh mt-32 pb-16 bg-p-wh flex items-center flex-col gap-8 border-2 border-t-bk rounded-lg absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pt-16"> */}
      <form
        className='flex flex-col md:flex-row gap-6 w-full box-border'
        onSubmit={handleSubmit}
      >
        <div className='flex flex-col gap-6 w-full'>
          <div className='flex flex-col md:flex-row gap-6 w-full'>
            <div className='flex flex-col gap-2 w-full'>
              <label className='text-p-bk text-base font-pin'>
                First name<sup className='text-red-500'>*</sup>
              </label>
              <input
                type='text'
                className=' focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk px-4 focus:outline-none focus:ring focus:b-mc'
                name='firstName'
                value={inputs.firstName}
                onChange={handleChange}
              />
              <small className='text-red-500'>{inputError.firstName}</small>
            </div>
            <div className='flex flex-col gap-2 w-full'>
              <label className='text-p-bk text-base font-pin'>
                Last name<sup className='text-red-500'>*</sup>
              </label>
              <input
                type='text'
                className=' focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk px-4 focus:outline-none focus:ring focus:b-mc'
                name='lastName'
                value={inputs.lastName}
                onChange={handleChange}
              />
              <small className='text-red-500'>{inputError.lastName}</small>
            </div>
          </div>

          <div className='flex flex-col gap-2 w-full'>
            <label className='text-p-bk text-base font-pin'>
              Personal email<sup className='text-red-500'>*</sup>
            </label>
            <input
              type='email'
              className=' focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk px-4 focus:outline-none focus:ring focus:b-mc'
              name='personalEmail'
              value={inputs.personalEmail}
              onChange={handleChange}
            />
            <small className='text-red-500'>{inputError.personalEmail}</small>
          </div>

          <div className='flex flex-col gap-2 w-full'>
            <label className='text-p-bk text-base font-pin'>
              Phone number<sup className='text-red-500'>*</sup>
            </label>
            <div className='flex flex-row gap-6'>
              <select
                name='countryCode'
                className='py-2 focus:outline-none focus:ring focus:b-mc border-2 w-1/3 h-11 rounded-lg border-t-bk pr-4'
                value={inputs.countryCode}
                onChange={handleChange}
              >
                <option className='py-8'></option>
                {countries.sort(sortArray).map((country) => (
                  <option key={country.id} className='py-8'>
                    {country.code}{' '}
                  </option>
                ))}
              </select>
              <input
                type='number'
                className='focus:outline-none focus:ring focus:b-mc border-2 w-2/3 h-11 rounded-lg border-t-bk px-4'
                name='phoneNumber'
                value={inputs.phoneNumber}
                onChange={handleChange}
              />
            </div>
            <small className='text-red-500'>{inputError.phoneNumber}</small>
          </div>

          <div className='flex flex-col gap-2 w-full'>
            <label className='text-p-bk text-base font-pin'>
              Country<sup className='text-red-500'>*</sup>
            </label>

            <select
              name='country'
              className='py-2 focus:outline-none focus:ring focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk pr-4'
              value={inputs.country}
              onChange={handleChange}
            >
              <option className='py-8'></option>
              {countries.sort(sortArray).map((country) => (
                <option key={country.id} className='py-8'>
                  {country.name}
                </option>
              ))}
            </select>
            <small className='text-red-500'>{inputError.country}</small>
          </div>
          <div className='w-full'>
            <div className='flex  items-start gap-3 w-full'>
              <input
                type='checkbox'
                className=' border-2 h-11 rounded-lg border-t-bk w-5'
                name='agree'
                checked={inputs.agree}
                onChange={handleChange}
              />
              <label className='text-p-bk text-sm md:text-base font-pin pt-2.5'>
                By checking the box you agree to the{' '}
                <br className='hidden md:block' />
                <span className='text-b-mc'>Terms</span> and{' '}
                <span className='text-b-mc'>Conditions</span> of the platform
              </label>
            </div>
            <small className='text-red-500'>{inputError.agree}</small>
          </div>
        </div>

        <div className='flex flex-col gap-6 w-full'>
          <div className='flex flex-col gap-2 w-full'>
            <label className='text-p-bk text-base font-pin'>
              Username<sup className='text-red-500'>*</sup>
            </label>
            <input
              type='text'
              className='focus:outline-none focus:ring focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk px-4'
              name='userName'
              value={inputs.userName}
              onChange={handleChange}
            />
            <small className='text-red-500'>{inputError.userName}</small>
          </div>

          <div className='flex flex-col gap-2 w-full'>
            <div className='flex flex-col gap-2 w-full relative'>
              <label className='text-p-bk text-base font-pin'>
                Password<sup className='text-red-500'>*</sup>
              </label>
              <input
                type={passwordShown ? 'text' : 'password'}
                className='focus:outline-none focus:ring focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk px-4'
                name='password'
                value={inputs.password}
                onChange={handleChange}
                onFocus={() => {
                  setInstruction(!instruction);
                }}
                onBlur={() => {
                  if (instruction) {
                    setInstruction(!instruction);
                  }
                }}
              />
              {passwordShown ? (
                <HiEye
                  className='absolute bottom-3 right-4'
                  onClick={togglePassword}
                />
              ) : (
                <HiEyeOff
                  className='absolute bottom-3 right-4 text-s-bk'
                  onClick={togglePassword}
                />
              )}
            </div>
            {instruction ? (
              <small className='bg-b-mct p-2 '>
                Minimum eight characters, at least one letter, one number and
                one special character
              </small>
            ) : null}
            <small className='text-red-500'>{inputError.password}</small>
          </div>

          <div className='flex flex-col gap-2 w-full'>
            <div className='flex flex-col gap-2 w-full relative'>
              <label className='text-p-bk text-base font-pin'>
                Confirm password<sup className='text-red-500'>*</sup>
              </label>
              <input
                type={confirmPasswordShown ? 'text' : 'password'}
                className='focus:outline-none focus:ring focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk px-4'
                name='confirmPassword'
                value={inputs.confirmPassword}
                onChange={handleChange}
                onFocus={() => {
                  setInstruction(!instruction);
                }}
                onBlur={() => {
                  if (instruction) {
                    setInstruction(!instruction);
                  }
                }}
              />
              {passwordShown ? (
                <HiEye
                  className='absolute bottom-3 right-4'
                  onClick={togglePassword}
                />
              ) : (
                <HiEyeOff
                  className='absolute bottom-3 right-4 text-s-bk'
                  onClick={togglePassword}
                />
              )}
            </div>

            <small className='text-red-500'>{inputError.confirmPassword}</small>
          </div>

          <div className='flex flex-col gap-2 w-full'>
            <label className='text-p-bk text-base font-pin'>
              Refferrer Code <span className='text-xs'>(Optional)</span>
            </label>
            <input
              type='number'
              className='focus:outline-none focus:ring focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk px-4'
              name='refferrerCode'
              value={inputs.refferrerCode}
              onChange={handleChange}
            />
          </div>
          <button
            className='text-p-wh px-4 py-2.5 w-full mt-2.5 hover:bg-blue-300 focus:bg-blue-400 font-semibold bg-b-mc rounded-lg'
            disabled={isLoading}
          >
            {isLoading ? 'Processing...' : 'Sign up'}
          </button>
        </div>
      </form>

      {/* </div> */}
    </div>
  );
}
export default Individual;
